// ID pomiaru GA4 z env
const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-7JYJN84KDC';
// Suffix ciasteczka (bez prefixu G-)
const GA_COOKIE_SUFFIX = MEASUREMENT_ID.replace(/^G-/, '');

// BEZPIECZNIK: true gdy gtag załadowany, ale nie odpowiada na callbacki (adblock scenariusz B)
// Zapobiega ponownemu wieszaniu się na gtag('get', ...) w kolejnych wywołaniach
let _ga4Blocked = false;

// Funkcja pomocnicza do odczytu cookie _ga
const readGaCookie = () => {
    const gaCookie = document.cookie
        .split('; ')
        .find(row => row.startsWith('_ga='));

    if (gaCookie) {
        const parts = gaCookie.split('.');
        if (parts.length >= 4) {
            const clientId = parts[2] + '.' + parts[3];
            return clientId;
        }
    }
    return null;
};

// Funkcja pomocnicza do odczytu GA4 session_id z ciasteczka _ga_XXXXXXXX
const readGaSessionCookie = () => {
    const sessionCookie = document.cookie
        .split('; ')
        .find(row => row.startsWith(`_ga_${GA_COOKIE_SUFFIX}=`));

    if (sessionCookie) {
        // Format: GS1.1.<SESSION_ID>.<session_count>.<session_number>.<engine_version>
        const value = sessionCookie.split('=')[1];
        const parts = value.split('.');
        if (parts.length >= 3) {
            return parts[2]; // session_id
        }
    }
    return null;
};

// Fallback przez ciasteczka z krótkim retry (max 5 × 300ms = 1.5s)
// Używa współdzielonej funkcji settle() aby zapobiec podwójnemu resolve
const resolveViaCookieFallback = (cookieReader, settle, attempts) => {
    const maxAttempts = 5;
    const retryInterval = 300;

    const value = cookieReader();
    if (value) {
        settle(value);
        return;
    }

    if (attempts < maxAttempts) {
        setTimeout(
            () => resolveViaCookieFallback(cookieReader, settle, attempts + 1),
            retryInterval
        );
    } else {
        settle(null);
    }
};

// Race: gtag('get', ...) callback vs safety timeout (2s)
// Jeśli timeout wygra → _ga4Blocked = true → kolejne wywołania pomijają gtag
const gtagGetWithTimeout = (fieldName, cookieReader, resolve) => {
    let settled = false;
    const GTAG_TIMEOUT_MS = 2000;
    let timeoutHandle;

    // Współdzielona funkcja settle — gwarantuje pojedyncze resolve
    const settle = (value) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutHandle);
        resolve(value);
    };

    // Safety timeout: 2s bez odpowiedzi od gtag → uznajemy za zablokowany
    timeoutHandle = setTimeout(() => {
        if (settled) return;
        _ga4Blocked = true;
        resolveViaCookieFallback(cookieReader, settle, 0);
    }, GTAG_TIMEOUT_MS);

    // Próba przez gtag
    gtag('get', MEASUREMENT_ID, fieldName, (value) => {
        if (value && value !== 'undefined' && typeof value === 'string') {
            settle(value);
        } else {
            // gtag odpowiedział, ale pustą wartością → fallback do ciasteczek
            clearTimeout(timeoutHandle);
            resolveViaCookieFallback(cookieReader, settle, 0);
        }
    });
};

// Funkcja do pobierania GA4 Client ID z bezpiecznikiem adblock
export const getGA4ClientId = () => {
    return new Promise((resolve) => {
        // Jeśli gtag już oznaczony jako zablokowany LUB w ogóle nie istnieje → od razu ciasteczka
        if (_ga4Blocked || typeof gtag !== 'function') {
            resolveViaCookieFallback(readGaCookie, (value) => resolve(value), 0);
            return;
        }

        // Normalna ścieżka: race gtag vs timeout
        gtagGetWithTimeout('client_id', readGaCookie, resolve);
    });
};

// Funkcja do pobierania GA4 Session ID z bezpiecznikiem adblock
export const getGA4SessionId = () => {
    return new Promise((resolve) => {
        // Jeśli gtag już oznaczony jako zablokowany LUB w ogóle nie istnieje → od razu ciasteczka
        if (_ga4Blocked || typeof gtag !== 'function') {
            resolveViaCookieFallback(readGaSessionCookie, (value) => resolve(value), 0);
            return;
        }

        // Normalna ścieżka: race gtag vs timeout
        gtagGetWithTimeout('session_id', readGaSessionCookie, resolve);
    });
};
